export default class Preloader {
    constructor(selector) {
        this.root = document.querySelector(selector);
        this.progress = document.createElement('div');
        this.progress.className = 'loading';
        this.progress.style = 'display:none;';
        this.progress.innerHTML = '<div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div>';
        this.root.appendChild(this.progress);
    }
    destroy() {
        this.root.removeChild(this.progress);
        delete this.root;
        delete this.progress;
    }
    show() {
        this.progress.style = '';
    }
    hide() {
        this.progress.style = 'display:none;';
    }
}
